import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addLocationBlogsFailure,
  //
  addLocationBlogsSuccess,
  deleteLocationBlogsFailure,
  //
  deleteLocationBlogsSuccess,
  editLocationBlogsFailure,
  //
  editLocationBlogsSuccess,
  fetchLocationBlogs as fetchLocationBlogsAction,
  fetchLocationBlogsFailure,
  fetchLocationBlogsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  setBlogFailure,
  //
  setBlogSuccess,
} from "./actions";
import {
  ADD_LOCATION_BLOGS,
  DELETE_LOCATION_BLOGS,
  EDIT_LOCATION_BLOGS,
  FETCH_LOCATION_BLOGS,
  GET_VIEW_DATA,
  OPEN_BLOG_EDIT_MODAL,
} from "./constants";

export function* fetchLocationBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location-blog?${query}`);
    yield put(fetchLocationBlogsSuccess(data));
  } catch (e) {
    yield put(fetchLocationBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching blogs!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-blog/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* getBlogData({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location-blog/${payload}`
    );
    yield put(setBlogSuccess(data));
  } catch (e) {
    yield put(setBlogFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addLocationBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location-blog/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Blog added successfully!"));
      yield put(addLocationBlogsSuccess());
      let fetchPayload = { page: 1, limit: 10 };
      if (payload?.isOriginLocation) {
        fetchPayload.location_id = payload?.location_id;
      } else {
        fetchPayload.company_id = payload?.company_id;
      }
      yield put(fetchLocationBlogsAction(fetchPayload));
    }
  } catch (e) {
    yield put(addLocationBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editLocationBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location-blog/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Blog updated successfully!"));
      yield put(editLocationBlogsSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editLocationBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteLocationBlogsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/location-blog/${payload.id}`
    );
    if (data) {
      yield put(successAlert("Blog deleted successfully!"));
      yield put(deleteLocationBlogsSuccess());
      let fetchPayload = { page: 1, limit: 10 };

      if (payload?.isOriginLocation) {
        fetchPayload.location_id = payload?.id;
      } else {
        fetchPayload.company_id = payload?.id;
      }
      yield put(fetchLocationBlogsAction(fetchPayload));
    }
  } catch (e) {
    yield put(deleteLocationBlogsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchLocationBlogsFlow() {
  yield takeEvery(FETCH_LOCATION_BLOGS, fetchLocationBlogsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addLocationBlogsFlow() {
  yield takeEvery(ADD_LOCATION_BLOGS, addLocationBlogsSaga);
}
export function* editLocationBlogsFlow() {
  yield takeEvery(EDIT_LOCATION_BLOGS, editLocationBlogsSaga);
}
export function* deleteLocationBlogsFlow() {
  yield takeEvery(DELETE_LOCATION_BLOGS, deleteLocationBlogsSaga);
}
export function* getBlogDataFlow() {
  yield takeEvery(OPEN_BLOG_EDIT_MODAL, getBlogData);
}

export default function* LocationBlogsSaga() {
  yield all([
    fetchLocationBlogsFlow(),
    addLocationBlogsFlow(),
    editLocationBlogsFlow(),
    deleteLocationBlogsFlow(),
    getViewDataFlow(),
    getBlogDataFlow(),
  ]);
}
